import { HTMLAttributes } from 'react';
import styles from './SkeletonLoader.scss';

// Replace these HTMLAttributes with your correct one
type SkeletonLoaderProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Use JS Doc Style Comments to add to the Documentation
   */
  width?: string;

  /**
   * Height of element, should be a string representation with units (% or px)
   */
  height?: string;

  /**
   * How much variation up to the max width (0 = none, 1 = 100%). Useful with `count`.
   */
  widthRandomness?: number;

  /**
   * How much variation up to the max height(0 = none, 1 = 100%). Useful with `count`.
   */
  heightRandomness?: number;

  /**
   * Number of skeleton bars to generate.
   */
  count?: number;
};

export const SkeletonLoader = ({
  className,
  width = '100%',
  height = '100%',
  widthRandomness = 0.1,
  heightRandomness = 0.0,
  count = 1,
}: SkeletonLoaderProps) => {
  const w = parseFloat(width);
  const h = parseFloat(height);
  const wm = width.toString().replace(/\d+/g, '');
  const hm = height.toString().replace(/\d+/g, '');
  const elements = [];

  for (let i = 0; i < count; i++) {
    const randomisedWidth = `${w - Math.random() * w * widthRandomness}${wm}`;
    const randomisedHeight = `${h - Math.random() * h * heightRandomness}${hm}`;
    elements.push(
      <span
        className={`skeleton ${styles.wrapper} ${styles.animated}`}
        key={i}
        style={{
          width: randomisedWidth,
          height: randomisedHeight,
          animation: `${styles.animated}`,
        }}
      >
        &zwnj;
      </span>
    );
    if (i !== count - 1) {
      elements.push(<br key={`br-${i}`} />);
    }
  }

  return (
    <div className={className}>
      <>{elements}</>
    </div>
  );
};

SkeletonLoader.displayName = 'SkeletonLoader';
